
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"512","height":"512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23 22H3a1 1 0 01-1-1V1a1 1 0 00-2 0v20a3 3 0 003 3h20a1 1 0 000-2z"}}),_c('path',{attrs:{"d":"M15 20a1 1 0 001-1v-7a1 1 0 00-2 0v7a1 1 0 001 1zm-8 0a1 1 0 001-1v-7a1 1 0 00-2 0v7a1 1 0 001 1zm12 0a1 1 0 001-1V7a1 1 0 00-2 0v12a1 1 0 001 1zm-8 0a1 1 0 001-1V7a1 1 0 00-2 0v12a1 1 0 001 1z"}})])
          )
        }
      }
    